
export type INumbers = number | `${number}`

export type IUrlOrString = string | URL
